export interface RegisterObject {
	loginInfo: {
		email: string;
		password: string;
		passwordConfirm: string;
	};
	userInfo: {
		name: string;
		surname: string;
		job: string;
		title: string;
		phone: string;
		gsm: string;
		companyType: string;
		companyName: string;
		province: string;
		district: string;
		address: string;
		isAgreementApprove: boolean;
	};
}

export const RegisterObjectInitialValue: RegisterObject = {
	loginInfo: {
		email: "",
		password: "",
		passwordConfirm: "",
	},
	userInfo: {
		name: "",
		surname: "",
		job: "",
		title: "",
		phone: "",
		gsm: "",
		companyType: "",
		companyName: "",
		province: "",
		district: "",
		address: "",
		isAgreementApprove: false,
	},
};

export interface SavedUserResponseDTO {
	email: string;
	name: string;
}
